import { Entity } from '@core/entities/entity'
import { IChecklistTemplate } from '@core/entities/checklist/ChecklistTemplate/IChecklistTemplate'
import { ChecklistTemplateVersion } from '@core/entities/checklist/ChecklistTemplateVersion'
import { plainToInstance, Type } from 'class-transformer'
import { User } from '@core/entities/user'
import { TemplateEditorChecklistTemplateStatus } from '@core/entities/checklist/TemplateEditorChecklistTemplate/types'
import { IFolderPath } from '@core/entities/folders/FolderPath'
import { ProcessTagsWrapper } from '@core/entities/processTags/ProcessTagsWrapper'
import { NotificationConfig } from '@core/entities/notifications/NotificationConfig'

export class ChecklistTemplate extends Entity<IChecklistTemplate> {
  id?: number

  status: TemplateEditorChecklistTemplateStatus

  organisationId: number

  organisationName?: string

  name: string

  description: string

  code?: string

  @Type(() => ChecklistTemplateVersion)
  currentVersion?: ChecklistTemplateVersion

  @Type(() => User)
  createdBy?: User

  @Type(() => User)
  modifiedBy?: User

  createdOn?: string

  modifiedOn?: string

  isCreatable?: boolean

  folderId?: number

  // TODO: get backend to return this folder object from all endpoints
  folder?: {
    pathFromRoot?: IFolderPath
  }

  requireGeolocationForChecklist?: boolean

  geoLocationInputTypes?: Array<'DEVICE_LOCATION'>

  pathFromRoot?: IFolderPath

  @Type(() => ProcessTagsWrapper)
  processTags?: ProcessTagsWrapper

  @Type(() => NotificationConfig)
  notifications?: NotificationConfig[]

  usedForInspections?: boolean

  public static new(payload: unknown): ChecklistTemplate {
    const entity = plainToInstance(ChecklistTemplate, payload)

    return entity
  }
}
